import { Box } from '@mui/material';
import { styled as styledMUI } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import { styled, css } from 'styled-components';
import getSubjectsType from '../../utils/get-Subject-Types';

interface TabProps {
  $subject: string;
  $color: 10 | 20 | 30 | 40 | 50 | 60 | 70;
}

export const TabsWrapper = styled(Box)(() => css`
  color: #ffffff;
  padding: 0 180px;
  margin: 24px 0;

  @media (max-width: 1000px) {
    padding: 0 92px;  
  }

  @media (max-width: 600px) {
    padding: 0 20px;
    margin: 16px 0;
  }
`);

export const TabsContainer = styled(Box)<TabProps>(() => css`
  a {
    color: #ffffff;
  }

  & > *, .listaBullets, .listaNumerica {
    padding: 0 !important;
  }

  li::marker {
    color: #fff !important;
  }

`);

export const TabsTitlesWrapper = styled(Box)<TabProps>(() => ({
  borderBottom: 2,
  borderColor: 'divider',
  backgroundColor: '#FFB99F',
}));

export const CustomTab = styledMUI(Tab)(() => ({
  fontFamily: 'Museo',
  '&.Mui-selected': {
    color: '#FFFFFF',
    backgroundColor: 'RGBA(240, 90, 34, 1)',
  },
  indicator: {
    display: 'none',
  },
}));

export const TabPanel = styled(Box)(({ theme }) => css`
  background-color: #F05A22;
  padding: 16px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;  

  @media (min-width: ${theme.breakpoints.tablet}) {
    padding: 16px 90px;
  }
  
  & > *, .listaBullets, .listaNumerica {
    padding: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  h5 p {
    font-family: unset;
    font-size: unset;
    font-weight: unset;
    padding: unset;
  }
`);
